import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["input", "preview", "dropzone"]

  connect() {
    // Listen to file input changes
    this.inputTarget.addEventListener('change', this.handleFiles.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener('change', this.handleFiles.bind(this))
  }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    this.inputTarget.click()
  }

  handleDragOver(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.add('border-blue-500', 'bg-blue-100')
  }

  handleDragLeave(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.remove('border-blue-500', 'bg-blue-100')
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dropzoneTarget.classList.remove('border-blue-500', 'bg-blue-100')

    const files = event.dataTransfer.files
    if (files.length > 0) {
      // Add dropped files to the input
      const dataTransfer = new DataTransfer()
      
      // Add existing files from input
      const existingFiles = this.inputTarget.files
      for (let i = 0; i < existingFiles.length; i++) {
        dataTransfer.items.add(existingFiles[i])
      }
      
      // Add new dropped files
      for (let i = 0; i < files.length; i++) {
        dataTransfer.items.add(files[i])
      }
      
      // Update the input
      this.inputTarget.files = dataTransfer.files
      
      // Show preview
      this.handleFiles()
    }
  }

  handleFiles() {
    const files = this.inputTarget.files
    this.previewTarget.innerHTML = ''

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      if (file.type.startsWith('image/')) {
        this.createPreview(file, i)
      }
    }
  }

  createPreview(file, index) {
    const reader = new FileReader()
    
    reader.onload = (e) => {
      const previewHtml = `
        <div class="relative group bg-white border border-gray-200 rounded-lg p-2 shadow-sm" style="max-width: 140px;">
          <div class="w-full h-24 bg-gray-100 rounded-md overflow-hidden mb-2" style="aspect-ratio: 1;">
            <img src="${e.target.result}" class="w-full h-full object-cover" alt="${file.name}">
          </div>
          <div class="text-xs text-gray-600 truncate font-medium mb-1">${file.name}</div>
          <button type="button" class="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity w-5 h-5 bg-red-500 text-white rounded-full flex items-center justify-center hover:bg-red-600 transition-colors" data-action="click->file-upload#removeFile" data-index="${index}">
            <i class="fa-solid fa-times text-xs"></i>
          </button>
        </div>
      `
      this.previewTarget.insertAdjacentHTML('beforeend', previewHtml)
    }
    
    reader.readAsDataURL(file)
  }

  removeFile(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.index)
    
    const dataTransfer = new DataTransfer()
    const files = this.inputTarget.files
    
    for (let i = 0; i < files.length; i++) {
      if (i !== index) {
        dataTransfer.items.add(files[i])
      }
    }
    
    this.inputTarget.files = dataTransfer.files
    this.handleFiles()
  }
}